import { defineStore } from 'pinia';
import { DEFAULT_LOCALE, Store } from '@/setup/globals';
import { setInitialData } from '@/stores/initial-data';
import { Link } from '@/types/link';
import { Locale } from '@/types/locales';
import { FooterNavigation, NavigationItem } from '@/types/navigation';
import { FooterContact, FooterSocialMediaLinks } from '@/types/session';

export type StoreState = {
  [key: string]: unknown;
  theme: string;
  locale: string;
  isEmbeddedSearchEnabled: boolean;
  isFavoritesEnabled: boolean;
  searchLocale: string;
  basePath: string;
  logoPath: string;
  logoLink: string;
  user: unknown; // TODO: type
  availableLocales: Locale[];
  mainNavigation: NavigationItem[];
  myNikoPortal: Link | null;
  footerNavigation: FooterNavigation[];
  footerSocialLinks: FooterSocialMediaLinks;
  footerContact: FooterContact;
  footerCopyrightText: string;
  footerTermsLink: Link;
  favoritesOverviewPageLink: string;
};

const storeName = Store.Session;

export default defineStore(storeName, {
  state: () => {
    const initialData: Partial<StoreState> = window.initialData?.[storeName] || {};

    const state: StoreState = {
      theme: 'theme-default',
      locale: DEFAULT_LOCALE,
      isEmbeddedSearchEnabled: true,
      isFavoritesEnabled: true,
      searchLocale: '',
      basePath: '/',
      logoPath: '',
      logoLink: '/',
      user: null,
      availableLocales: [],
      mainNavigation: [],
      myNikoPortal: null,
      footerNavigation: [],
      footerSocialLinks: {} as FooterSocialMediaLinks,
      footerContact: {} as FooterContact,
      footerCopyrightText: '',
      footerTermsLink: {} as Link,
      favoritesOverviewPageLink: '',
    };

    setInitialData(state, initialData);

    return state;
  },

  getters: {
    getTheme(state): string {
      return state.theme;
    },
  },

  actions: {
    setTheme(id: string) {
      this.theme = id;
    },
  },
});
